import { Switch } from "./ui/switch";
import { Slider } from "./ui/slider";
import { MOOD_META } from "../lib/moods";

export default function SessionOptions({ primary, primaryName, blendOn, setBlendOn, mood2, setMood2, blend, setBlend, excludeRecent, setExcludeRecent }) {
  const others = Object.entries(MOOD_META).filter(([k]) => k !== primary);
  const name2 = MOOD_META[mood2]?.name;
  return (
    <section className="mt-10">
      <h2 className="font-extrabold text-2xl tracking-tight mb-4">Options</h2>
      <div className="bg-[#181818] rounded-lg divide-y divide-[#282828]">
        <div className="p-5">
          <label className="flex items-center justify-between gap-4 cursor-pointer">
            <div>
              <div className="font-bold">Mélanger avec un 2e mood</div>
              <div className="text-sm text-[#B3B3B3]">Ex : Chill × Nostalgique, dosé comme tu veux</div>
            </div>
            <Switch data-testid="blend-switch" checked={blendOn} onCheckedChange={setBlendOn} disabled={!primary} />
          </label>
          {blendOn && primary && (
            <div className="mt-5">
              <div className="flex flex-wrap gap-2">
                {others.map(([k, m]) => (
                  <button
                    key={k}
                    data-testid={`blend-mood-${k}`}
                    onClick={() => setMood2(k)}
                    className={`rounded-full px-4 py-1.5 text-sm font-semibold ${mood2 === k ? "sp-chip-active" : "sp-chip text-white"}`}
                  >
                    {m.emoji} {m.name}
                  </button>
                ))}
              </div>
              {mood2 && (
                <div className="mt-5">
                  <div className="flex justify-between text-sm font-bold mb-3">
                    <span data-testid="blend-share-1">{primaryName} {100 - blend}%</span>
                    <span data-testid="blend-share-2" className="text-[#FF2E93]">{name2} {blend}%</span>
                  </div>
                  <Slider data-testid="blend-slider" value={[blend]} min={10} max={90} step={10} onValueChange={(v) => setBlend(v[0])} />
                </div>
              )}
            </div>
          )}
        </div>
        <label className="p-5 flex items-center justify-between gap-4 cursor-pointer">
          <div>
            <div className="font-bold">Éviter les titres récents</div>
            <div className="text-sm text-[#B3B3B3]">Ignore les chansons de tes 5 dernières playlists générées</div>
          </div>
          <Switch data-testid="exclude-recent-switch" checked={excludeRecent} onCheckedChange={setExcludeRecent} />
        </label>
      </div>
    </section>
  );
}
